import * as Sentry from '@sentry/react';
import { AddInError } from '../addInError';
import { handleError } from './handleError';

export const OFFICE_READY_TIMEOUT_MS = 10 * 1000;

export type OfficeUnavailableCause = 'officeStringsFailed' | 'unknown';

// Thrown by office.js when office_strings.js fails to download; Office.onReady then never resolves.
export const OFFICE_STRINGS_FAILED_MESSAGE = 'provided by the host app nor the fallback locale';

const isOfficeStringsFailure = (event: ErrorEvent) =>
  [event.error, event.message].some(
    (value) => typeof value === 'string' && value.includes(OFFICE_STRINGS_FAILED_MESSAGE),
  );

export const startOfficeReadyWatchdog = (onTimeout: (cause: OfficeUnavailableCause) => void) => {
  let cause: OfficeUnavailableCause = 'unknown';

  const onError = (event: ErrorEvent) => {
    if (isOfficeStringsFailure(event)) cause = 'officeStringsFailed';
  };

  window.addEventListener('error', onError);

  const timer = setTimeout(() => {
    window.removeEventListener('error', onError);
    Sentry.setTag('office.unavailable_cause', cause);
    handleError(
      new AddInError('Office.onReady never resolved', {
        timeoutMs: OFFICE_READY_TIMEOUT_MS,
        cause,
      }),
    );
    onTimeout(cause);
  }, OFFICE_READY_TIMEOUT_MS);

  return () => {
    clearTimeout(timer);
    window.removeEventListener('error', onError);
  };
};
